<template>
  <!-- 大货库存列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="itemBtn" @click="myModel"
        >表格设置</el-button
        >
        <template >
          <div class="tableExportBtn">
            <exportTb
                :theadData="myTableHeard"
                :tableData="tableData"
                :resultData="tableData"
                @handleExportDia_dc="handleExportDia_dc('大货库存列表')"
            ></exportTb>
          </div>
        </template>
<!--        <el-button plain :disabled="mainID === ''" class="jy-button"-->
<!--        >打印拣货单</el-button-->
<!--        >-->

        <!-- <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field === 'aaaaaaaaaa' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel">
                {{ scope.row.aaaaaaaaaa }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
      ></sorttable>

    <!-- 导出插件 -->
    <exportComponent
        :isShowDialog_dc="exportForm.isShowDialog_dc"
        :diaWidth_dc="exportForm.diaWidth_dc"
        :diaHeight_dc="exportForm.diaHeight_dc"
        :dialogTitle="exportForm.dialogTitle"
        :dialogForm_dc="exportForm.dialogForm_dc"
        :data="exportForm.queryForm"
        :tableHeard="exportForm.EPtableHeard"
        :AllCheck="exportForm.EPAllCheck"
        @checktabEP="checktabEP"
        @checkAllEP="checkAllEP"
        @onAfterEnter="onAfterEnter"
        @handleCloseDia_dc="handleCloseDia_dc"
        @diaConfirmBtn_dc="diaConfirmBtn_dc"
        queryType="exportModeList"
    >
    </exportComponent>
  </div>
</template>
  <script>
import tableList from "@/pages/DynamicList/tableList.js";
  import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import utils from "@/assets/js/tool";
//   import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import customerModelService from "@/components/customerService/modelIndex.vue";
import { Api } from "@/assets/js/api";
import exportTb from "@/components/exportComponent/exportTb.vue";
import exportComponent from "@/components/exportComponent/index.vue";
import tableListNew from "@/pages/tableListNew.js";

export default {
  mixins: [tableList,tableListNew],
  inject: ["reload"],
  components: {
    exportComponent,
    exportTb,
      sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    customerModelService,
  },
  data() {
    return {
      sortName: "大货库存列表",
      userList: [],

      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "大货库存列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd===等待下载完成,bdd===不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DynamicListBillPackStockList", //  页面标识
      reportFiledsNumber: "bill_pack_stock_list_v4", // 动态 条件、表头

      currentItemArr: [],
    };
  },
  mounted() {
    this.queryBtn_ok();
  },
  watch: {},
  methods: {
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
    },

    // 不能输入负数
    minNum(val) {
      return val < 0 ? 0 : val;
    },

  },




};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}

.classA {
  display: flex;
}

.glo_dialogForm .diaForm .dialogFormItems {
  height: 30px !important;
  line-height: 30px !important;
  overflow: hidden;
}

.couponBox {
  width: 100%;
  margin-bottom: 20px;
  height: 34px;

  .couponitmeInput {
    width: 100px;
    border: 1px solid #cccccc;
    margin: 0 6px;

    ::v-deep .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }

  .couponItemA {
    display: flex;
    align-items: center;
  }
}

.displays {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.rows {
  display: flex;
  width: 100%;
}

.multipleSelect {
  ::v-deep .el-select {
    border: 1px solid #cccccc;
    border-radius: 4px;
  }
}
</style>
  